<template>
  <div class="magic-link ma-auto text-center pb-5">
    <iconMagicLink class="mt-4"/>
    <div class="text mt-4">{{ $t('settings.magicLink.description') }}</div>
    <magic-link-button/>
  </div>
</template>

<script>
import iconMagicLink from '@/static/custom-img/magic-link.svg';
import magicLinkButton from '@/components/base/magicLinkButton';

export default {
  name: 'magicLink',

  components: {
    iconMagicLink,
    magicLinkButton,
  },
};
</script>

<style lang="scss" scoped>
.magic-link {
  }

.text {
  font-weight: 600;
font-size: 18px;
line-height: 24px;
  width: 290px;
  margin: auto;
/* or 133% */

text-align: center;

/* Text / Gray */

color: #44445E;
}
</style>
